/** Primeiro e último dia de um mês relativo ao de `hoje` (0 = corrente, −1 = anterior), datas civis. */
export function mesDe(hoje: Date, deslocamento: number): { de: string; ate: string } {
  const inicio = new Date(hoje.getFullYear(), hoje.getMonth() + deslocamento, 1);
  const fim = new Date(inicio.getFullYear(), inicio.getMonth() + 1, 0);
  const dd = (n: number) => String(n).padStart(2, '0');
  const civil = (d: Date) =>
    `${String(d.getFullYear())}-${dd(d.getMonth() + 1)}-${dd(d.getDate())}`;
  return { de: civil(inicio), ate: civil(fim) };
}
